/* ============================================================
   PROVIDER BAHASA — dipasang SEKALI di main.jsx
   ============================================================
   Fail ini sengaja mengeksport SATU benda sahaja: komponen
   provider. Semua pemalar dan hook duduk dalam ./index.js —
   lihat nota di sana untuk sebabnya, dan untuk peraturan
   penamaan kunci kamus.
   ============================================================ */

import { useState, useCallback, useMemo } from 'react';
import { KonteksBahasa, bacaBahasaTersimpan, bahasaSah, cari, KUNCI_SIMPAN } from './index';

export default function LangProvider({ children }) {
    const [lang, setLangState] = useState(bacaBahasaTersimpan);

    const setLang = useCallback((baharu) => {
        if (!bahasaSah(baharu)) return;
        try {
            localStorage.setItem(KUNCI_SIMPAN, baharu);
        } catch {
            /* storan disekat — pilihan hidup untuk sesi ini sahaja */
        }
        /* Dicap pada <html lang> supaya pembaca skrin dan semakan
           ejaan browser mengikut bahasa yang dipilih, bukan hanya
           teks pada skrin. */
        document.documentElement.setAttribute('lang', baharu);
        setLangState(baharu);
    }, []);

    const t = useCallback((kunci, vars) => cari(lang, kunci, vars), [lang]);

    const nilai = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

    return <KonteksBahasa.Provider value={nilai}>{children}</KonteksBahasa.Provider>;
}
